module.exports = __webpack_public_path__ + "static/media/Sunnie.d571fbd1.png";